export const patchResolver = <T>(newFormData: any, originalFormData: any): Partial<T> => {
	const sentKeys: string[] = Object.keys(newFormData ?? {})

	const response = {}

	sentKeys.forEach((key) => {
		if (!(newFormData[key] === originalFormData[key])) {
			Object.assign(response, { [key]: newFormData[key] })
		}
	})

	return response
}
